module.exports = __webpack_public_path__ + "img/Partnership Icon - white.9c009ea7.svg";